import { render, staticRenderFns } from "./M2.vue?vue&type=template&id=72de3b1a&scoped=true&"
import script from "./M2.vue?vue&type=script&lang=js&"
export * from "./M2.vue?vue&type=script&lang=js&"
import style0 from "./M2.vue?vue&type=style&index=0&id=72de3b1a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72de3b1a",
  null
  
)

export default component.exports